export default __webpack_public_path__ + "static/acu_full-91c9affb6b607d5eab3be8d00948dd97.jpg";